import React, { memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, func, string, bool } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function AIButton({
  icon,
  onClick: handleClick = NOOP,
  label,
  ariaLabel,
  disabled = false,
}) {
  return (
    <div className="ai-button">
      <Button
        icon={icon}
        type="secondary"
        size="tiny"
        variant="with-icon"
        onClick={handleClick}
        aria-label={ariaLabel}
        customClass="ai-button__button"
        disabled={disabled}
      >
        {label}
      </Button>
    </div>
  )
}

AIButton.propTypes = {
  icon: node.isRequired,
  onClick: func,
  label: string.isRequired,
  ariaLabel: string.isRequired,
  disabled: bool,
}

export default memo(AIButton)
